import React, { createContext, useContext, useState } from "react";

const PageHeaderContext = createContext(null);

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error("usePageHeader must be used within a PageHeaderProvider");
  }
  return context;
};

export const PageHeaderProvider = ({ children }) => {
  const [headerContent, setHeaderContent] = useState(null);
  return (
    <PageHeaderContext.Provider value={{ headerContent, setHeaderContent }}>
      {children}
    </PageHeaderContext.Provider>
  );
};
